import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { func, getDate } from '@/utils/public';
import { templatePanel, templateDetail, addTemplate } from './request';
import customModel from './customModel.vue';
import echartsItem from './echartsItem.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import moment from 'moment';
export default {
  components: {
    topTitle,
    customModel,
    echartsItem
  },
  props: {
    customerId: {
      type: Number,
      default: 0
    },
    menu: {
      type: String,
      default: 'home.dashboardFrontPage'
    },
    type: {
      type: String,
      default: ''
    },
    queryMethod: {
      //时间筛选方式
      type: String,
      default: ''
    },
    timeFrame: {
      type: String,
      default: ''
    },
    bulletinBoardList: {
      type: Object,
      default() {
        return {};
      }
    },
    frontPage: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      panelList: [],
      previewList: [],
      current: 0,
      isPanelShow: false,
      panelIndex: null,
      homeList: []
    };
  },
  created() {
    this.$nextTick(() => {
      if (this.menu.indexOf('dashboardFrontPage') > -1) {
        if (!this.frontPage.previewList) {
          this.panelList = [];
          // this.getResourceFun();
          this.getTemplateDetail();
        } else {
          this.panelList = this.frontPage.panelList;
          this.previewList = this.frontPage.previewList;
        }
      } else {
        const INFO = this.bulletinBoardList[this.type];
        if (!INFO) {
          this.panelList = [];
          // this.getResourceFun();
          this.getTemplateDetail();
        } else {
          if (INFO.length != 0) {
            this.panelList = INFO.panelList;
            this.previewList = INFO.previewList;
            this.$emit('setInfo', {
              queryMethod: INFO.queryMethod,
              timeFrame: INFO.timeFrame
            });
          } else {
            // this.getResourceFun();
            this.getTemplateDetail();
          }
        }
      }
    });
  },
  methods: {
    formatDate(date) {
      let _date = date.split('~');
      _date = moment(_date[0]).format(this.getFormatDate()) + '~' + moment(_date[1]).format(this.getFormatDate());
      return _date || '';
    },
    async getTemplateDetail() {
      this.panelList = await templatePanel({
        customerId: this.customerId,
        menu: this.menu,
        type: this.type
      });
      const {
        frontPage,
        dataBoard
      } = await templateDetail({
        customerId: this.customerId
      });
      this.homeList = frontPage || [];
      if (this.menu.indexOf('dashboardFrontPage') > -1 && frontPage) {
        const arr = frontPage.sort(func) || [];
        let arr_new = [null, null, null, null, null];
        arr.map(item => {
          arr_new.splice(item.sort - 1, 1, item);
        });
        this.previewList = arr_new;
        this.$emit('setItem', this.type);
      } else if (this.menu.indexOf('dashboardDataBoard') > -1 && dataBoard) {
        let dataBoardArr = [];
        dataBoard.map(item => {
          if (item.keyType == this.type) {
            dataBoardArr = item.children;
          }
        });
        const arr = dataBoardArr.sort(func) || [];
        let arr_new = [null, null, null, null, null];
        arr.map(item => {
          arr_new.splice(item.sort - 1, 1, item);
        });
        this.previewList = arr_new;
        if (arr.length != 0) {
          this.$emit('setInfo', arr[0]);
        } else {
          this.$emit('setInfo', {
            queryMethod: 'WHOLE',
            timeFrame: 'MONTH'
          });
        }
        this.$emit('setItem', this.type);
      } else if (this.menu.indexOf('dashboardDataBoard') > -1 && !dataBoard) {
        this.$emit('setInfo', {
          queryMethod: 'WHOLE',
          timeFrame: 'MONTH'
        });
      }
    },
    handlePanel(val, index) {
      if (this.previewList[this.current]) {
        return this.$message.error(this.$t('先删除再配置面板'));
      }
      this.isPanelShow = true;
      this.panelIndex = index;
      this.$nextTick(() => {
        this.$refs.customFrom.init(val);
      });
    },
    titleFun(val) {
      let name = '';
      if (val && val.panel && val.panel.length != 0 && val.panel[0].name) {
        name = val.panel[0].name;
      }
      return name;
    },
    addTemplateFun(val, itemData) {
      const obj = {
        customerId: this.customerId,
        menu: this.menu,
        type: this.type,
        queryMethod: '',
        timeFrame: '',
        panelId: itemData.id,
        sort: this.current + 1,
        showForm: val.showForm,
        dictionariesId: val.id ? val.id.join(',') : '',
        dictionaries: val.dictionaries,
        panel: [itemData]
      };
      this.previewList[this.current] = obj;
      this.panelList.splice(this.panelIndex, 1);
      this.$emit('setItem', this.type);
      setTimeout(() => {
        if (this.current != 4) {
          this.current = this.current + 1;
        }
      }, 400);
    },
    async handleDelPanel(val) {
      if (this.previewList[val].createAt) {
        this.$emit('delArr', this.previewList[val]);
      }
      this.panelList.push(this.previewList[val].panel[0]);
      this.previewList.splice(val, 1, null);
    },
    getTimeFrame(val) {
      const dateInfo = getDate(val);
      return dateInfo.startTime + '~' + dateInfo.endTime;
    },
    async onSubmit() {
      let parameter = {};
      if (this.menu.indexOf('dashboardDataBoard') > -1) {
        let arr = [];
        for (let i in this.bulletinBoardList) {
          if (i != this.type && this.bulletinBoardList[i].previewList.length != 0) {
            for (let j = 0; j < this.bulletinBoardList[i].previewList.length; j++) {
              if (this.bulletinBoardList[i].previewList[j]) {
                // eslint-disable-next-line
                this.bulletinBoardList[i].previewList[j].queryMethod = this.bulletinBoardList[i].queryMethod;
                // eslint-disable-next-line
                this.bulletinBoardList[i].previewList[j].timeFrame = this.bulletinBoardList[i].timeFrame;
                arr.push(this.bulletinBoardList[i].previewList[j]);
              }
            }
          }
        }
        let arr2 = recursionCopy(this.previewList).filter(item => item.panelId);
        if (arr2.length != 0) {
          arr2.map(item => {
            item.queryMethod = this.queryMethod;
            item.timeFrame = this.timeFrame;
            item.type = this.type;
          });
          arr = arr.concat(arr2);
          // arr.push({panelList: this.panelList,
          //   timeFrame: this.timeFrame,
          //   queryMethod: this.queryMethod,
          //   previewList: this.previewList,
          //   type:this.type});
        }
        if (arr.length == 0) {
          return this.$message.error(this.$t('至少要配置一个'));
        }
        // arr.map(item => {
        //   data.push({data:item.previewList,menu:this.menu,type:item.type});
        // });
        parameter = {
          data: arr,
          menu: this.menu,
          type: ''
        };
        // return false;
      } else {
        let arr = recursionCopy(this.previewList).filter(item => item.panelId);
        if (arr.length == 0) {
          return this.$message.error(this.$t('至少要配置一个'));
        }
        arr.map(item => {
          item.queryMethod = this.queryMethod;
          item.timeFrame = this.timeFrame;
          item.type = this.type;
        });
        parameter = {
          data: arr,
          menu: this.menu,
          type: this.type
        };
      }
      await addTemplate(parameter);
      window.scrollTo(0, 0);
      this.$emit('ok');
      // if (this.menu.indexOf('dashboardDataBoard') > -1) {
      //   if (this.homeList.length == 0) {
      //     this.$emit('back');
      //   } else {
      //     this.$emit('ok');
      //   }
      // } else {
      //   this.$emit('ok');
      // }
    }
  }
};